module.exports = __webpack_public_path__ + "static/media/icon_hybrid_brain_ai.a31fda74.svg";